import PropTypes from 'prop-types';

const imagePropTypes = PropTypes.shape({
  description: PropTypes.string,
  url: PropTypes.string.isRequired,
});

export default imagePropTypes;
